import { AuthPage } from '../../components/auth/AuthPage';

const LoginPage = () => {
  return <AuthPage />;
};

export default LoginPage;